import { FirebaseApp, initializeApp } from 'firebase/app'
import { getFirestore, connectFirestoreEmulator, Firestore } from 'firebase/firestore'
import { getAuth, connectAuthEmulator, Auth } from 'firebase/auth'
import { getStorage, connectStorageEmulator, FirebaseStorage } from 'firebase/storage'
import { getFunctions, connectFunctionsEmulator, Functions } from 'firebase/functions'


let firebaseService: FirebaseService
let useEmulator: boolean = (location.hostname === 'localhost' || location.hostname === '127.0.0.1')


export default class FirebaseService {
  private _firebaseApp: FirebaseApp
  private _firestore: Firestore
  private _auth: Auth
  private _storage: FirebaseStorage
  private _functions: Functions

  public async init() {
    const config = await fetch('/__/firebase/init.json').then(response => response.json())

    this._firebaseApp = initializeApp(config)
    this._firestore = getFirestore(this._firebaseApp)
    this._auth = getAuth(this._firebaseApp)
    this._storage = getStorage(this._firebaseApp)
    this._functions = getFunctions(this._firebaseApp, 'us-east1')

    return this
  }

  public static async getApp() {
    if (firebaseService) {
      return firebaseService
    }

    firebaseService = await new FirebaseService().init()

    if (useEmulator) {
      connectFirestoreEmulator(firebaseService._firestore, 'localhost', 55002)
      connectAuthEmulator(firebaseService._auth, 'http://localhost:9099')
      connectStorageEmulator(firebaseService._storage, 'localhost', 9199)
      connectFunctionsEmulator(firebaseService._functions, 'localhost', 55001)
    }
    return firebaseService
  }

  public static async auth() {
    return (await FirebaseService.getApp())._auth
  }

  public static async firestore() {
    return (await FirebaseService.getApp())._firestore
  }

  public static async storage() {
    return (await FirebaseService.getApp())._storage
  }

  public static async functions() {
    return (await FirebaseService.getApp())._functions
  }

  public static async firebaseApp() {
    return (await FirebaseService.getApp())._firebaseApp
  }
}
